/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Adsense_CodeInputs */

const en_admin_settings_fields_adsense_code = /** @type {(inputs: Admin_Settings_Fields_Adsense_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publisher ID`)
};

const zh_admin_settings_fields_adsense_code = /** @type {(inputs: Admin_Settings_Fields_Adsense_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publisher ID`)
};

/**
* | output |
* | --- |
* | "Publisher ID" |
*
* @param {Admin_Settings_Fields_Adsense_CodeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_adsense_code = /** @type {((inputs?: Admin_Settings_Fields_Adsense_CodeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Adsense_CodeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_adsense_code(inputs)
	return zh_admin_settings_fields_adsense_code(inputs)
});
export { admin_settings_fields_adsense_code as "admin.settings.fields.adsense_code" }